/* eslint-disable no-param-reassign */
import produce from 'immer';
var experimentSettingsExcludeGenesDeleted = function experimentSettingsExcludeGenesDeleted(state, action) {
  var _state$info;
  var experimentId = action.payload.experimentId;
  var experimentSettingsExperimentId = state === null || state === void 0 || (_state$info = state.info) === null || _state$info === void 0 ? void 0 : _state$info.experimentId;
  var shouldUpdateExperimentSettings = experimentSettingsExperimentId === experimentId;
  if (!shouldUpdateExperimentSettings) {
    return state;
  }
  return produce(state, function (draft) {
    draft.info.excludeGenes = {};
    return draft;
  });
};
export default experimentSettingsExcludeGenesDeleted;